import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { useFormikContext } from 'formik';

type FormikSubmitButtonProps = ButtonProps & {
  loadingText?: string;
};

export const FormikSubmitButton = ({
  children,
  loadingText = 'Submitting...',
  variant = 'contained',
  ...props
}: FormikSubmitButtonProps) => {
  const { isSubmitting } = useFormikContext();

  return (
    <Button type="submit" variant={variant} disabled={isSubmitting} {...props}>
      {isSubmitting ? (
        <>
          <CircularProgress size={24} sx={{ mr: 1 }} />
          {loadingText}
        </>
      ) : (
        children
      )}
    </Button>
  );
};
